import Header from "../../../../Components/Header/Header"
import Sidebar from "../../../../Components/Sidebar/Sidebar"
import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import DeletePopup from "../GardenPopup/DeletePopup"
import UserCreationPopup from "./UserCreationPopup"
import { useAuthState } from "../../../../Helper/Context"
import { useDispatch, useSelector } from "react-redux"
import { UserCreationDeleteAPI, UserCreationExportTableDataAPI, UserCreationTableDataAPI } from "../../../../Redux/SidebarMasterSlice/UserCreationSlice"
import { RoleNameDataDDL } from "../../../../Components/CommonDDL/RoleNameDataDDL"
import { EmployeeDataDDL } from "../../../../Components/CommonDDL/EmployeeDataDDL"
import { Loading } from "../../../../Helper/Loading"
import { Pegination } from "../../../../Components/Pegination/Pegination"
import { useSearchParams } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { UserCreationExportData } from "./UserCreationExportData"
import { NewDepartmentDDL } from "../../../../Components/CommonDDL/NewDepartmentDDL"
import { NewRoleDataDDL } from "../../../../Components/CommonDDL/NewRoleDDL"
import CommonDashboardWardNameDDL from "../CommonDashboardWardNameDDL"
import WardAndZoneDDL from "../../../../Components/CommonDDL/UserCreationDDL/WardAndZoneDDL"
import { ContractorNameDDL } from "../../../../Components/CommonDDL/ContractorNameDDL"
import { ZoneUserNameDDL } from "../../../../Components/CommonDDL/UserCreationDDL/ZoneUserDDL"
import { WardUserDDL } from "../../../../Components/CommonDDL/UserCreationDDL/WardUserDDL"


export const UserCreation = () => {

    const { t } = useTranslation()

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let Lang = searchParams.get("Lang")

    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [From, setFrom] = useState(1)
    const [To, setTo] = useState(10)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [IsPost, setIsPost] = useState(false)
    const [WardMasterPopupShow, setWardMasterPopupShow] = useState()
    const [DeletePopupShow, setDeletePopupShow] = useState()

    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')
    const [UserCreationPopupShow, setUserCreationPopupShow] = useState()
    const [IsClear, setIsClear] = useState(false)

    const [WardValue, setWardValue] = useState(null)
    const [WardLabel, setWardLabel] = useState(null)

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setUserCreationPopupShow(true)
    }
    const handleEditOnClick = (item) => {
        setUserCreationPopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }

    const handleOnCloseClick = () => {
        setUserCreationPopupShow(false)
    }

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: 0,
        Label: 'Select...'
    })

    const [NewRoleDDL, setNewRoleDDL] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [NewDepartment, setNewDepartment] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [EmployeeDDL, setEmployeeDDL] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [Designation, setDesignation] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",

    })
    const [Department, setDepartment] = useState({
        DDL: [],
        ID: 0,
        Label: 'Select...',
    })

    const [ZoneNameDDLID, setZoneNameDDLID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [ContractorName, setContractorName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [Language, setLanguage] = useState({
        DDL: [],
        ID: 0,
        Label: ''
    })

    useEffect(() => {
        setLanguage({
            ...Language,
            DDL: [],
            ID: 0,
            Label: localStorage.getItem('LanguageChange'),
        })
    }, [])

    const handleIsPost = () => {
        setIsPost(!IsPost)
    }

    const handlerClear = () => {
        setFrom(1)
        setTo(10)
        setCurrentPage(0)
        setIsClear(!IsClear)
        setNewDepartment({
            ...NewDepartment,
            ID: 0,
            Label: 'Select...',
        })
        setNewRoleDDL({
            ...NewRoleDDL,
            ID: 0,
            Label: 'Select...',
        })

        setEmployeeDDL({
            ...EmployeeDDL,
            ID: 0,
            Label: 'Select...',
        })
        setZoneNameDDLID({
            ...ZoneNameDDLID,
            ID: 0,
            Label: 'Select...',
        })
        setWardName({
            ...WardName,
            ID: 0,
            Label: 'Select...'
        })
        setContractorName({
            ...ContractorName,
            ID: 0,
            Label: 'Select...',
        })
    }
    useEffect(() => {
        const data = {
            M_Table_UserID: '0',
            M_RoleID: NewRoleDDL.ID,
            M_DesignationID: '0',
            M_EmployeeID: EmployeeDDL.ID,
            M_UsersID: UserID,
            token: token,
            From: From,
            To: To,
            M_DepartmentID: NewDepartment.ID,
            M_ZoneID: ZoneNameDDLID.ID,
            M_WardID: WardName.ID,
            M_ContractorID: ContractorName.ID
        }
        dispatch(UserCreationTableDataAPI({ data }))
    }, [IsPost, IsClear, To, NewRoleDDL.ID, EmployeeDDL.ID, NewDepartment.ID, ZoneNameDDLID.ID, WardName.ID, ContractorName.ID])

    const { tableData, isLoading } = useSelector(state => state.UserCreationTableData)


    useEffect(() => {
        const data = {
            M_Table_UserID: '0',
            M_RoleID: NewRoleDDL.ID,
            M_DesignationID: '0',
            M_EmployeeID: EmployeeDDL.ID,
            M_UsersID: UserID,
            token: token,
            From: From,
            To: '99999',
            M_DepartmentID: NewDepartment.ID,
            M_ZoneID: ZoneNameDDLID.ID,
            M_WardID: WardName.ID,
            M_ContractorID: ContractorName.ID
        }
        dispatch(UserCreationExportTableDataAPI({ data }))
    }, [IsPost, IsClear, To, NewRoleDDL.ID, EmployeeDDL.ID, NewDepartment.ID, ZoneNameDDLID.ID, WardName.ID, ContractorName.ID])

    const { ExportTableData, isExportLoading } = useSelector(state => state.UserCreationExportTableData)


    const handleDeleteApi = (item) => {
        const data = {
            M_Table_UserID: item.m_UserID,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost
        }
        dispatch(UserCreationDeleteAPI({ data }))
    }

    const { isDeleteLoading } = useSelector(state => state.UserCreationDeleteData)

    // useEffect(() => {
    //     setCurrentPage(0)
    //     setFrom(1)
    //     setTo(10)
    // }, [NewRoleDDL.ID, EmployeeDDL.ID])

    return (
        <>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <div>
                <Header
                    // DashboardHeading="Garden Maintainance"
                    DashboardName={DashboardName}
                    Language={Language}
                    setLanguage={setLanguage}
                />
                <div className="wrapper">
                    <Sidebar
                        Language={Language}
                        ProjectTypeId={ProjectTypeId} />
                    <div className="content">
                        <div className="data_mob">
                            <div className="row  m-1 py-1 pb-4 master_border">
                                <div className="d-flex">
                                    <h5 className="ps-1 py-1 "> {t('AdminDashboard.Admin_Sidebar_Name.User_Creation')}</h5>
                                    <div className="col-12 col-lg-10 ml-lg-5">
                                        <i className="fa-solid fa-plus btn btn-secondary float-end mb-2" onClick={handleAddOnClick} style={{ color: "white" }}
                                        >
                                            <text className="ml-2 poppins">Add</text>
                                        </i>
                                        {
                                            isExportLoading ?
                                                <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                    <i
                                                        className="fa fa-refresh fa-spin"
                                                        style={{ marginRight: "5px" }}
                                                    />Loading</button>
                                                :
                                                ExportTableData && ExportTableData.table && ExportTableData.table.length > 0 &&
                                                <UserCreationExportData
                                                    ExcelData={ExportTableData}
                                                    name={t('AdminDashboard.Admin_Sidebar_Name.User_Creation')}
                                                // searchName={searchName}
                                                />
                                        }
                                    </div>
                                </div>
                                <div className="row m-0 ">
                                    <div className="col-12 py-1 rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: " #27466317" }}>
                                        <div className="col-12  ">

                                            <div className="row py-1 rounded2">

                                                <div className="col-12 col-md-6 col-lg-3 ">
                                                    <NewDepartmentDDL
                                                        NewDepartment={NewDepartment}
                                                        setNewDepartment={setNewDepartment}
                                                    />
                                                </div>

                                                <div className="col-12 col-md-6 col-lg-3">
                                                    <NewRoleDataDDL
                                                        NewRoleDDL={NewRoleDDL}
                                                        setNewRoleDDL={setNewRoleDDL}
                                                        NewDepartment={NewDepartment}
                                                    />
                                                </div>

                                                <div className="col-12 col-md-6 col-lg-3">
                                                    <ZoneUserNameDDL
                                                        ZoneNameDDLID={ZoneNameDDLID}
                                                        setZoneNameDDLID={setZoneNameDDLID}
                                                        Language={Language}
                                                    />
                                                </div>
                                                <div className="col-12 col-md-6 col-lg-3">
                                                    <WardUserDDL
                                                        WardName={WardName}
                                                        setWardName={setWardName}
                                                        // WLable={WLable}
                                                        // HWard={HWard}
                                                        // flag={flag}
                                                        Language={Language}
                                                        // M_ZoneID={ZoneNameDDLID.ID}
                                                        ZoneNameDDLID={ZoneNameDDLID}
                                                    />
                                                </div>
                                                <div className="col-12 col-md-6 col-lg-3">
                                                    <EmployeeDataDDL
                                                        EmployeeDDL={EmployeeDDL}
                                                        setEmployeeDDL={setEmployeeDDL}
                                                        Designation='0'
                                                        Department={Department}
                                                    />
                                                </div>

                                                <div className="col-12 col-md-6 col-lg-3">
                                                    <ContractorNameDDL
                                                        ContractorName={ContractorName}
                                                        setContractorName={setContractorName}
                                                        IsPost={IsPost}
                                                        Language={Language}
                                                        Flag='Master'
                                                    />
                                                </div>
                                                <div className="col-12 col-md-1 col-lg-1 mt-lg-4 mt-md-4" >
                                                    <button type="button"
                                                        className="btn-clear btn btn-primary"
                                                        onClick={handlerClear}>Clear</button>

                                                </div>
                                            </div>
                                            <div className="row mob_table table-responsive pt-1">

                                                <table id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th className="sr_no_col">Sr No.</th>
                                                            <th>Role</th>
                                                            {/* <th>Department Name</th> */}
                                                            <th>Designation</th>
                                                            <th>Employee Name</th>
                                                            <th>Table User Name</th>
                                                            <th>User Name</th>
                                                            <th>Password</th>
                                                            <th>Status</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                                <tr style={{ width: '100%' }}>
                                                                    <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                    <td>{item.m_RoleName ? item.m_RoleName : '-'}</td>
                                                                    {/* <td></td> */}
                                                                    <td>{item.designationName ? item.designationName : '-'}</td>
                                                                    <td>{item.employeeName ? item.employeeName : '-'}</td>
                                                                    <td>{item.tableUserName ? item.tableUserName : '-'}</td>
                                                                    <td>{item.userName ? item.userName : '-'}</td>
                                                                    <td>{item.password ? item.password : '-'}</td>
                                                                    <td>{item.statusName ? item.statusName : '-'}</td>
                                                                    <td style={{ textAlign: "center", width: '7%' }}>

                                                                        <span>
                                                                            <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => handleEditOnClick(item)}
                                                                            >
                                                                            </i>
                                                                        </span>

                                                                        <DeletePopup
                                                                            open={DeletePopupShow}
                                                                            item={item}
                                                                            handleDeleteApi={handleDeleteApi}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ))
                                                                :
                                                                <></>
                                                        }

                                                    </tbody>
                                                </table>

                                            </div>
                                            {tableData && tableData.table && tableData.table.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData.table[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                    IsClear={IsClear}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                {
                    UserCreationPopupShow ?
                        <UserCreationPopup
                            open={UserCreationPopupShow}
                            // popupHeading="Location Name"                         
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                        />
                        : <></>
                }
            </div >
        </>
    )
}